<template>
  <div>
    <JobList />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import ogImageDe from '@/assets/images/seo/jobs-og-image-de.png'
import JobList from '@/components/JobList.vue'

import { useRuntimeConfig, useHead } from '#imports'

const {
  public: { rootDomain },
} = useRuntimeConfig()

const { t } = useI18n()

useHead(() => ({
  title: t('seo.job_board.title'),
  meta: [
    // Facebook OpenGraph
    {
      id: 'og:title',
      property: 'og:title',
      content: t('seo.job_board.title'),
    },
    {
      id: 'og:image',
      property: 'og:image',
      content: new URL(ogImageDe, rootDomain).href,
    },
  ],
}))
</script>
